// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = Partial<WidgetProps> & HasProduct;

export interface ProductDetailsCustomerPartNumberStyles {
    wrapper?: InjectableCss;
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const customerPartNumberStyles: ProductDetailsCustomerPartNumberStyles = {
    wrapper: {
        css: css`
            display: flex;
            margin-right: 50px;
        `,
    },
    labelText: {
        size: "14px",
        lineHeight: "20px",
        weight: "bold",
    },
    valueText: {
        size: "14px",
        lineHeight: "20px",
    },
};

const styles = customerPartNumberStyles;

const ProductDetailsCustomerPartNumber: React.FC<Props> = ({ product }) => {
    if (!product.customerProductNumber) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.labelText}>{translate("CPN #:")}&nbsp;</Typography>
            <Typography {...styles.valueText} data-test-selector="customerProductNumber">
                {product.customerProductNumber}
            </Typography>
        </StyledWrapper>
    );
};

export const CustomerPartNumberComponent: React.FC<Props> = ProductDetailsCustomerPartNumber;

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsCustomerPartNumber),
    definition: {
        displayName: "Customer Part Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
